import VectorSource from "ol/source/Vector";
import { useLazyRef } from "../useLazyRef";

export default function useDrawSource() {
  // useRef(new VectorSource()) 는 매 렌더마다 throwaway 인스턴스를 생성한다 — lazy-init(D7).
  const ref = useLazyRef(() => new VectorSource());
  return { drawVectorSource: ref.current };
}
